var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vote-image-container"},[_c('question',_vm._b({ref:"question"},'question',{ poll: _vm.poll, question: _vm.question },false)),(_vm.question.image || (_vm.poll.isDisplayed && _vm.isPieChart))?_c('flex-two-columns',[(_vm.question.image)?_c('question-image',{attrs:{"question":_vm.question,"headerHeight":_vm.headerHeight}},[(_vm.poll.isDisplayed && _vm.isPieChart)?_c('pie-chart',{staticClass:"pie-chart-with-image",attrs:{"stats":_vm.statsOfQuestion,"poll":_vm.poll}}):_vm._e()],1):(_vm.isPieChart)?_c('pie-chart',{staticClass:"pie-chart-without-image",attrs:{"stats":_vm.statsOfQuestion,"poll":_vm.poll}}):_vm._e(),(_vm.headerHeight > 0)?_c('answers',_vm._b({},'answers',{
          answers: _vm.answers,
          question: _vm.question,
          stats: _vm.statsOfQuestion,
          poll: _vm.poll,
          headerHeight: _vm.headerHeight
        },false)):_vm._e()],1):_c('div',[(_vm.headerHeight > 0)?_c('answers',_vm._b({},'answers',{
      answers: _vm.answers,
      question: _vm.question,
      stats: _vm.statsOfQuestion,
      poll: _vm.poll,
      headerHeight: _vm.headerHeight
    },false)):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }